export const OVERLAY_DISPLAY_SNAPSHOT_TOPIC = 'overlay:display-snapshot'

export interface OverlayNotchBounds {
  x: number
  y: number
  width: number
  height: number
}

export interface OverlayDisplaySnapshot {
  revision: number
  notchBounds: OverlayNotchBounds | null
  /** Height of the system bar along the display's top edge (macOS menu bar); 0 when there is none. */
  menuBarHeight: number
}

export const EMPTY_OVERLAY_DISPLAY_SNAPSHOT: OverlayDisplaySnapshot = {
  revision: 0,
  notchBounds: null,
  menuBarHeight: 0,
}
